export default __webpack_public_path__ + "static/DenisMann-d7ba1c2dfd8c7ea3c0a5f34301fb1a7e.png";